
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partnership/factoring-partners",
      function () {
        return require("private-next-pages/partnership/factoring-partners/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partnership/factoring-partners"])
      });
    }
  